import axios from 'axios';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    'messageType',
    'organizationId',
    'assignEl',
    'informEl',
    'closeAssignElBtn',
    'assignElBtn',
    'informElBtn',
    'closeInformElBtn',
    'supportContent',
    'feedbackContent',
    'patientContent',
    'patientSelect',
    'actOnBehalfContainer',
    'actOnBehalfOrgIdContainer',
  ];

  static values = {
    ambikiOrgId: String,
    url: String,
  };

  // Initialize act on behalf visibility based on the current organization and message type
  connect() {
    this.updateActOnBehalfVisibility();
    this.initializeActOnBehalfOrganization();
  }

  toggleAssignView() {
    this.assignElTarget.classList.toggle('d-none');
    this.assignElBtnTarget.classList.toggle('d-none');
    this.closeAssignElBtnTarget.classList.toggle('d-none');
  }

  toggleInformView() {
    this.informElTarget.classList.toggle('d-none');
    this.informElBtnTarget.classList.toggle('d-none');
    this.closeInformElBtnTarget.classList.toggle('d-none');
  }

  // Show support or feedback content based on the message category type
  typeChange() {
    this.supportContentTarget.classList.toggle('d-none');
    this.feedbackContentTarget.classList.toggle('d-none');
    this.updateActOnBehalfVisibility();

    // Clear the "act on behalf" field when changing message type to non-support
    if (this.messageTypeTarget.value !== 'support') {
      this.clearActOnBehalfField();
    }
  }

  // Handle organization change:
  // 1. Toggle patient select dropdown visibility based on selected organization
  // 2. Clear patient selection if applicable
  // 3. Update act on behalf container visibility
  // 4. Check whether the Act on behalf Organization dropdown should be available for the selected user
  orgChange(event) {
    const selectedOrgId = event.target.selectize.getValue();
    const messageContent = document.getElementById('message_content');
    this.patientContentTarget.classList.toggle('d-none', selectedOrgId !== this.currentOrgId);

    if (this.hasPatientSelectTarget && this.patientSelectTarget.selectize) {
      this.patientSelectTarget.selectize.clear();
      this.patientSelectTarget.selectize.clearOptions();
    }

    this.updateActOnBehalfVisibility();

    if (messageContent) {
      messageContent.dataset.mentionsOrganizationValue = selectedOrgId;
    }
  }

  // Hide act on behalf container if the organization is not Ambiki or the message type is not support
  updateActOnBehalfVisibility() {
    if (this.hasActOnBehalfContainerTarget) {
      const isAmbikiOrg = this.organizationIdTarget.value === this.ambikiOrgIdValue;
      const isSupport = this.messageTypeTarget.value === 'support';
      const notAmbikiOrSupport = !(isAmbikiOrg && isSupport);

      this.actOnBehalfContainerTarget.classList.toggle('d-none', notAmbikiOrSupport);

      // Clear the "act on behalf" field when hiding it
      if (notAmbikiOrSupport) {
        this.clearActOnBehalfField();
      }
    }
  }

  clearActOnBehalfField() {
    const actOnBehalfContainer = document.getElementById('act_on_behalf_user_id').closest('.form-group');
    const autocomplete = actOnBehalfContainer.querySelector('awc-autocomplete');
    if (autocomplete) {
      autocomplete.clear();
      this.clearOrgAutocomplete;
    } else {
      throw new Error('Autocomplete clear button not found for act on behalf field');
    }
  }

  initializeActOnBehalfOrganization() {
    if (this.hasActOnBehalfContainerTarget) {
      const actOnBehalfContainer = document.getElementById('act_on_behalf_user_id').closest('.form-group');
      const autocomplete = actOnBehalfContainer.querySelector('awc-autocomplete');

      if (autocomplete) {
        // Set autocomplete event handlers
        autocomplete.addEventListener('awc-autocomplete:commit', (event) => {
          this.clearOrgAutocomplete.bind(this);
          const userId = autocomplete.value;
          axios
            .get('/auto_complete/organizations', {
              params: { v2: true, for_user_id: userId },
              headers: { Accept: 'text/fragment+html' },
            })
            .then((result) => {
              autocomplete.classList.remove('is-invalid');
              const orgSelectAutocomplete = this.actOnBehalfOrgIdContainerTarget.querySelector('awc-autocomplete');
              // Parse HTML fragment
              const options = document.createElement('div');
              options.innerHTML = result.data;

              if (options.children.length === 1) {
                this.actOnBehalfOrgIdContainerTarget.classList.add('d-none');
                // Set the id
                // orgSelectAutocomplete.
                const orgId = options.children[0].attributes.value.value;
                const orgName = options.children[0].dataset.text;
                orgSelectAutocomplete.setValue(orgId, orgName);
              } else {
                this.actOnBehalfOrgIdContainerTarget.classList.remove('d-none');
                this.actOnBehalfOrgIdContainerTarget.querySelector(
                  'awc-autocomplete div .awc-autocomplete-options'
                ).innerHTML = result.data;
              }
            })
            .catch((error) => {
              autocomplete.classList.add('is-invalid');
            });
        });

        autocomplete.addEventListener('awc-autocomplete:clear', this.clearOrgAutocomplete.bind(this));
      }
    }
  }

  clearOrgAutocomplete() {
    const orgSelectAutocomplete = this.actOnBehalfOrgIdContainerTarget.querySelector('awc-autocomplete');
    orgSelectAutocomplete.removeValue();
    orgSelectAutocomplete.querySelector('awc-autocomplete div .awc-autocomplete-options').innerHTML = null;
    this.actOnBehalfOrgIdContainerTarget.classList.add('d-none');
  }
}
